import React from "react";
import Grid from "@material-ui/core/Grid";
import CardButton from "../CardButton";
import StringFormat from "../../../../util/string-format";
import BaseKeyListener from "../listeners/BaseKeyListener";

const ListSelector = ({
	items = [],
	selected = {},
	onSelected,
	disableKeyListener
}) => {
	return (
		<Grid container spacing={1} justifyContent="flex-start">
			{items.map((p) => (
				<Grid item xs={12} sm={3} key={p.code}>
					<CardButton
						size="small"
						textAlign="center"
						text={
							<span>
								<span>{StringFormat.formatTextWithKeystroke(p.name, p.keyStroke)}</span>
							</span>
						}
						onClick={() => onSelected(p)}
						active={selected.code === p.code}
						id={p.name.toLowerCase().replace(" ", "-")}
					/>
				</Grid>
			))}
			<Grid item xs={12}>
				{!disableKeyListener && (
					<BaseKeyListener items={items} onSelected={onSelected} />
				)}
			</Grid>
		</Grid>
	);
};

export default ListSelector;
